<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <!-- Logo -->
                  <div class="text-center mb-3">
                    <img :src="darkMode || sidebarType === 'bg-default' ? logoWhite : logo" class="img-fluid" alt="Logo"
                      style="max-height: 200px;">
                  </div>
                  <h4 class="font-weight-bolder">Iniciar Sesión</h4>
                  <p class="mb-0">Ingresa tu correo y contraseña.</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleLogin">
                    <div class="mb-3">
                      <argon-input id="email" type="email" placeholder="Correo" name="email" size="lg"
                        v-model="email" />
                    </div>
                    <div class="mb-3 position-relative">
                      <argon-input ref="passwordInputRef" id="password" :type="showPassword ? 'text' : 'password'"
                        placeholder="Contraseña" name="password" size="lg" v-model="password" />
                      <!-- Icono toggle de contraseña -->
                      <span id="togglePassword" class="position-absolute top-50 end-0 translate-middle-y pe-3 fs-5"
                        style="cursor: pointer;" @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash-fill'" id="toggleIcon"></i>
                      </span>
                    </div>
                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="warning" fullWidth size="lg" type="submit">
                        Iniciar Sesión
                      </argon-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${require('@/assets/img/automation.jpeg')})`,
                  backgroundSize: 'cover'
                }">
                <span class="mask bg-gradient-warning opacity-6"></span>
                <h1 class="mt-5 text-white font-weight-bolder position-relative">
                  CREATING VALUE
                </h1>
                <h4 class="text-white position-relative">
                  THROUGH TECHNOLOGY.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

import { computed } from "vue";
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import logo from "@/assets/img/allo-powered.png";
import logoWhite from "@/assets/img/allo-powered-white.png";

const body = document.getElementsByTagName("body")[0];

const darkMode = computed(() => store.state.darkMode);
const showPassword = ref(false)

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const email = ref('');
const password = ref('');
const router = useRouter();

const handleLogin = async () => {
  try {
    // Validar que los campos no estén vacíos
    if (!email.value || !password.value) {
      alert('Por favor llena todos los campos.');
      return;
    }

    const response = await axios.post(`${API_BASE_URL}/login`, {
      email: email.value,
      password: password.value,
    });

    if (response.data) {
      if (response.data.msg) {
        alert(response.data.msg);
      } else if (response.data.tkn) {
        // Guardar token en localStorage
        localStorage.setItem('authToken', response.data.tkn);
        // Redirigir a la página de inicio
        router.push('/home');
      }
    } else {
      alert('Error, no hubo una respuesta de parte del servidor.');
    }
  } catch (error) {
    console.error('Error al iniciar sesión:', error);
  }
};
</script>
